import firebase from 'firebase/app';
import { db } from '../firebase';

export async function updateBookmark(update, user, docId) {
    const docRef = db.collection('ideas').doc(docId);
    const userRef = db.collection('users').doc(user.uid);
    await db.runTransaction(transaction => {
        return transaction.get(docRef).then(doc => {
            if(!doc.exists) throw "Document does not exist!"
            const saveCount = doc.data().saveCount;
            if(update === 'add') {
                transaction.update(docRef, {saveCount: firebase.firestore.FieldValue.increment(1)})
                transaction.update(userRef, {saved: firebase.firestore.FieldValue.arrayUnion(docId)})
            }else {
                if(saveCount > 0) transaction.update(docRef, {saveCount: firebase.firestore.FieldValue.increment(-1)})
                transaction.update(userRef, {saved: firebase.firestore.FieldValue.arrayRemove(docId)})
            }
        }).catch((error) => {
            console.log('Couldn\'t update bookmark.');
        })
    })
}